import React from 'react'
import TransparentVideo from '../../components/TransparentVideo'
import Video from 'sparkol-web-component-library/src/components/video'

import videoPoster from './video-poster.png'
import './pricingpageHeroVideo.scss'

const PricingpageHeroVideo = props => {
  const videoPosterElement = <img src={videoPoster} className="video__fallback--pricing" />

  return (
    <div className="hero__video--pricing">
      <TransparentVideo fallback={videoPosterElement}>
        <Video {...props} preload="metadata" />
      </TransparentVideo>
    </div>
  )
}

export default PricingpageHeroVideo
